import script from "./PerformerProjectFormStep7.vue?vue&type=script&setup=true&lang=js"
export * from "./PerformerProjectFormStep7.vue?vue&type=script&setup=true&lang=js"

import "./PerformerProjectFormStep7.vue?vue&type=style&index=0&id=2bce9fb6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bce9fb6"]])

export default __exports__